import { TableBody } from '@mui/material';
import React from 'react';

import CertificateRow from './components/CertificateRow';

const ManageCertificateTableBody = ({
  listCertificate,
  page,
  pageSize,
  highlightCertificateCode,
}) => {
  return (
    <TableBody>
      {(listCertificate || []).map((certificate, index) => (
        <CertificateRow
          key={index}
          index={index}
          certificate={certificate}
          page={page}
          pageSize={pageSize}
          highlightCertificateCode={highlightCertificateCode}
        />
      ))}
    </TableBody>
  );
};

export default ManageCertificateTableBody;
